import React, { useCallback, useState } from 'react';

import moment from 'moment';

import { DateAndTimeContext, IDateAndTimeContext } from '../../hooks';

const DateAndTimeProvider: React.FC = ({ children }) => {
  const [day, setDay] = useState<IDateAndTimeContext['day']>(null);
  const [time, setTime] = useState<IDateAndTimeContext['time']>(null);

  const handleSetDay = useCallback<IDateAndTimeContext['setDay']>(
    newDay => {
      if (moment(newDay.date).isSame(moment(day?.date))) return;

      setDay(newDay);
      setTime(null);
    },
    [day],
  );

  return (
    <DateAndTimeContext.Provider
      value={{ day, time, setDay: handleSetDay, setTime }}
    >
      {children}
    </DateAndTimeContext.Provider>
  );
};

export default DateAndTimeProvider;
